module.exports = __webpack_public_path__ + "img/Insurance.a31d48b1.svg";